import FileDownloadIcon from '@mui/icons-material/FileDownload'
import { Button } from '@mui/material'
import type { useGridApiRef } from '@mui/x-data-grid'

interface ExportCSVProps {
  onClick?: () => void
  disabled?: boolean
  ref: ReturnType<typeof useGridApiRef>
  fileName?: string
}

export default function ExportCSV({ onClick, disabled, ref, fileName }: ExportCSVProps) {
  const handleClick = () => {
    ref.current?.exportDataAsCsv({
      fileName: fileName || `export-${Date.now()}`,
    })
    onClick?.()
  }

  return (
    <Button variant="outlined" startIcon={<FileDownloadIcon />} onClick={handleClick} disabled={disabled}>
      Export CSV
    </Button>
  )
}
